import React from 'react';

import Map from '@rover/icons/svg/map.svg';
import Rebook from '@rover/icons/svg/rebook.svg';
import ReviewStarFill from '@rover/icons/svg/review-star-fill.svg';
import { Flex, Heading, Text } from '@rover/kibble/core';
import { useStarColor } from '@rover/kibble/patterns/StarRating/StarRating.common';
import useDeviceContext from '@rover/react-lib/src/context/useDeviceContext';

const ICON_SIZE = 16;

interface GroomingInfoColumnProps {
  resultNumber: number;
  shortName: string;
  ratingsAverage?: string | null;
  reviewsCount: number;
  repeatClientCount: number;
  distanceDisplay: string;
}

function GroomingInfoColumn({
  resultNumber,
  shortName,
  ratingsAverage,
  reviewsCount,
  repeatClientCount,
  distanceDisplay,
}: GroomingInfoColumnProps): JSX.Element {
  const { isDesktop } = useDeviceContext();
  const starFill = useStarColor();
  const rating = parseFloat(ratingsAverage ?? '') || 0;

  return (
    <Flex flex="1 1 0" flexDirection="column" px="4x" gap="1x">
      <Heading size={isDesktop ? '300' : '200'} mb="0x">
        {`${resultNumber}. ${shortName}`}
      </Heading>
      {reviewsCount > 0 && (
        <Flex gap="1x" alignItems="center">
          {rating > 0 ? (
            <>
              <ReviewStarFill width={ICON_SIZE} height={ICON_SIZE} fill={starFill} />
              <Text size="100">
                <Text size="100" fontWeight="semibold">
                  {rating.toFixed(1)}
                </Text>
                {` (${reviewsCount})`}
              </Text>
            </>
          ) : (
            <Text size="100">{`${reviewsCount} ${reviewsCount === 1 ? 'review' : 'reviews'}`}</Text>
          )}
        </Flex>
      )}
      {repeatClientCount > 0 && (
        <Flex gap="1x" alignItems="center">
          <Rebook width={ICON_SIZE} height={ICON_SIZE} />
          <Text size="100">
            {`${repeatClientCount} ${repeatClientCount === 1 ? 'repeat client' : 'repeat clients'}`}
          </Text>
        </Flex>
      )}
      {distanceDisplay && (
        <Flex display={['flex', 'none']} gap="1x" alignItems="flex-start">
          <Map width={ICON_SIZE} height={ICON_SIZE} />
          <Text size="100">{distanceDisplay}</Text>
        </Flex>
      )}
    </Flex>
  );
}

export default GroomingInfoColumn;
